import router from '@/router'
import { navigateTo } from '@/router/navigateTo'
import { useDossierStore } from './useDossierStore'

export function useDossierRoutingService() {
  const store = useDossierStore()

  async function loadStoreWithKey(key: any): Promise<boolean> {
    try {
      await store.loadData(key)
      return true
    } catch {
      return false
    }
  }

  function navigateToRechercheDossiersList() {
    const backPath = window.history.state.back as string | undefined
    const isBackToRecherche = backPath && /\/formations\/dossiers(\?|$)/.test(backPath)

    if (isBackToRecherche) {
      router.go(-1)
    } else {
      return navigateTo({
        to: 'recherche',
        domaine: 'formations',
        module: 'dossier'
      })
    }
  }

  return { loadStoreWithKey, navigateToRechercheDossiersList }
}

